import GeofenceFilters from './geofence-filters'
import GeofenceList from './geofence-list'
import GeofenceMap from './geofence-map'
import GeofencePriority from './geofence-priority'
import GeofencePromo from './geofence-promo'
import GeofenceServicearea from './geofence-servicearea'
import ArrivalInstruction from './arrival-instruction'

let sharedMutations = []
sharedMutations = sharedMutations.concat(ArrivalInstruction.sharedMutations)

export default {
  strict: false,
  namespaced: true,
  state: Object.assign(
    GeofenceFilters.state,
    GeofenceList.state,
    GeofenceMap.state,
    GeofencePriority.state,
    GeofencePromo.state,
    GeofenceServicearea.state,
    ArrivalInstruction.state
  ),
  mutations: Object.assign(
    GeofenceFilters.mutations,
    GeofenceList.mutations,
    GeofenceMap.mutations,
    GeofencePriority.mutations,
    GeofencePromo.mutations,
    GeofenceServicearea.mutations,
    ArrivalInstruction.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/geofences/index.js